import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .target-Img": {
      width: 170,
      height: 85,
    },
    "& .target-Info": {
      width: "100%",
    },
    "& .width76": {
      width: "calc(100% - 70px)",
      textAlign: "left",
      "& h6": {
        fontSize: 14,
      },
      "& .date, .desc": {
        fontSize: 12,
      },
    },
  },
  simpleCarousel: {
    position: "relative",
    "& .arrow-buttons": {
      bottom: 16,
      position: "absolute",
      left: 0,
      right: 0,
      textAlign: "center",
      "& button": {
        height: 30,
        width: 30,
        margin: "0 30px",
        boxShadow: "0px 0px 3px #7395B778",
        "& svg": {
          color: theme.palette.primary.main,
          fontSize: 20,
        },
        "&.Mui-disabled": {
          boxShadow: "none",
          border: "1.5px solid #F0F0F0",
          "& svg": {
            color: "#99A1A5",
          },
        },
      },
    },
    "& .slider-count": {
      position: "absolute",
      bottom: 21,
      left: 0,
      right: 0,
      margin: "0 auto",
      fontWeight: 500,
      color: "#767677",
    },
  },
  tableHeader: {
    background: "#F7F7F8",
    height: 38,
    "& p": {
      fontSize: 12,
      fontWeight: 500,
    },
  },
  colTitle: {
    width: "60%",
  },
  colComment: {
    width: "20%",
    textAlign: "center",
  },
  colStatus: {
    width: "20%",
    textAlign: "center",
    paddingRight: 10,
  },
  listWrapper: {
    borderBottom: "solid 1px #EAEAEA",
  },
}));

export default useStyles;
